import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { Radio, Tooltip, Paper, Badge, Button } from '@material-ui/core';
import DotIcon from '@material-ui/icons/Lens';
import EditIcon from '@material-ui/icons/Edit';
import NotificationsIcon from '@material-ui/icons/Notifications';

import MaterialTable from 'material-table';

import OrderDashboard from '../../../../models/OrderDashboard';
import DoneIcon from '@material-ui/icons/CheckCircleOutlineOutlined';
import PauseIcon from '@material-ui/icons/PauseCircleOutline';

import { truckStatusTime } from '../../../../utils/truckStatusTime';

import ghaOrdersListStyles from './ghaOrdersList.module.css';
import commonStyles from '../../../common/common.module.css';
import { AttachFile, Print } from '@material-ui/icons';

const styles = (theme: Theme) =>

  createStyles({
    green: {
      color: 'green !important',
      fontSize: '14px'
    },
    red: {
      color: 'red !important',
      fontSize: '14px',
    },
    yellow: {
      color: 'orange',
      fontSize: '14px'
    },
    editHover: {
      '&:hover': {
        cursor: 'pointer'
      }
    },
    disabledIcon: {
      color: 'rgb(204, 204, 204)'
    },
    radio:{ 
      fontSize: '14px',
      padding: '0px'
    }, 
    tableSection: {
      '& td':{
        color : 'inherit !important'
      }
    },
    statusClass: {
      display: 'flex',
      alignItems: 'center'
    },
    ordersPaper: {
      '& .MuiPaper-root': {
        backgroundColor: 'transparent',
        boxShadow: 'none',
      }
    },
    label: {
      fontSize: '11px',
      color: 'var(--primaryblue)',
      fontWeight: 500,
      paddingBottom: '1px',
      textTransform: 'capitalize',
    },
    containedSizeSmall: {
      padding: '2px 8px',
      textTransform: 'capitalize',
    },
    tableButton: {
      borderRadius: '4px',
      cursor: 'pointer',
      textAlign: 'center',
      display: 'inline-block',
      margin: 0,
      marginLeft: '10px',
      lineHeight: '1.4',
      boxShadow: 'none',
    }
  });

interface GhaOrdersListProps {
  classes: any;
  ordersList: Array<OrderDashboard>;
  selectedOrderNumber: string;
  handleChange: (number: string) => void;
  openDrvTrkEdit: (data: OrderDashboard) => void;
  openAttachments: (data: OrderDashboard) => void;
  printOrderInfoClicked: (orderNumber: string) => void; 
  openModal: (type: string, order: OrderDashboard) => void;
};

const PADDING_RIGHT_CELLS = '14px';
const PADDING_LEFT_CELLS = '10px';
const cellStyle = { paddingRight: PADDING_RIGHT_CELLS, paddingLeft: PADDING_LEFT_CELLS };
const headerStyle = { paddingRight: PADDING_RIGHT_CELLS, paddingLeft: PADDING_LEFT_CELLS };

const ghaOrdersList = (props: GhaOrdersListProps) => {

  const { classes, ordersList } = props;

  return (    
    <div className={`${ classes.tableSection } ${ classes.ordersPaper } ${ commonStyles.paperTable } ${ commonStyles.SelectTable }`} >
      <MaterialTable
        data={ ordersList }        
        onRowClick={ (event: any, rowData: any) => props.handleChange(rowData.number) }

        columns={[ 

          { title: 'Order #', field: 'number_type', cellStyle: { whiteSpace: 'nowrap' }, headerStyle,
            render: (rowData: OrderDashboard) => {
              if(!rowData.isManualEntry){
                return (
                  <div>
                    {rowData.number_type}{((rowData as any).was_go === "true" || (rowData as any).was_go === true || (rowData as any).parent_go_id) && !rowData.number_type.includes("(GO)") ? " (GO)" : ""} <NotificationsIcon className={ ghaOrdersListStyles.bell } />
                  </div>
                  );
              } else {
                return <>{rowData.number_type}{((rowData as any).was_go === "true" || (rowData as any).was_go === true || (rowData as any).parent_go_id) && !rowData.number_type.includes("(GO)") ? " (GO)" : ""}</>;
              }
            
            } 
          },
          { title: 'Trucking Company', field: 'delivery_company_name', cellStyle, headerStyle,
            render: (rowData: OrderDashboard) => {

              const rowOrderNbr: string = rowData.number;
              const selectedOrderNbr: string = props.selectedOrderNumber;
              const styleClass: string = rowOrderNbr === selectedOrderNbr ? classes.editHover : classes.disabledIcon;

              return <div className={ ghaOrdersListStyles.editTrkDrvButtonWrapper }>
                        <div className={ ghaOrdersListStyles.trkCompanyName }>{ rowData.delivery_company_name }</div>
                        { rowData.allowed_ops.update_dispatch_driver_details &&
                          <Tooltip title="Edit trucking company and driver details">
                            <EditIcon fontSize="small" className={ styleClass } onClick={ () => rowOrderNbr === selectedOrderNbr ? props.openDrvTrkEdit(rowData) : {} } />
                          </Tooltip>
                        }
                      </div>;
            }
          },
          { title: 'Awbs', field: 'num_awbs', cellStyle, headerStyle },
          { title: 'Dock', field: 'dock_name', cellStyle, headerStyle, 
            render: (rowData: OrderDashboard) => {
              return rowData.dock_name || 'None'
            } 
          },
          {
            title: 'Ind', field: 'color_status', cellStyle , headerStyle,
            render: (rowData: OrderDashboard) => {
              const colorClass: any = rowData.suspended ? classes.yellow : classes[rowData.color_status];
              return <DotIcon className={ colorClass } />;
            }
          },
          {
            title: 'Truck Status', field: 'truck_status', cellStyle:{ minWidth: '150px'}, headerStyle:{ minWidth: '150px'} ,
            render: (rowData: OrderDashboard) => {
                const status = truckStatusTime(rowData);
                return rowData.truck_status.type === 0 ? <div className={ classes.statusClass }><DoneIcon className={ commonStyles.mr1 }></DoneIcon><span>{status}</span></div> : <div>{status}</div>
              }
          },
          { 
            title: 'Action', cellStyle, headerStyle,
            render: (rowData: OrderDashboard) => {
              return <span className={`${ ghaOrdersListStyles.awbActionsList } ${ ghaOrdersListStyles.actionList}`} >
                {rowData.suspended && !rowData.isManualEntry ?
                 <Button variant='contained' size='small' 
                 className={ classes.materialIcon }
                 classes={{ root: classes.tableButton,
                  containedSizeSmall: classes.containedSizeSmall,
                  label: classes.label
                 }}  
                 onClick={ () => props.openModal('unsuspend', rowData) } >
                  Reactivate
                </Button>
              :
                <>
                 {!rowData.suspended && !rowData.isManualEntry && !rowData.delivered_date && <Tooltip title="Suspend Order">
                    <PauseIcon className={ classes.materialIcon } onClick={ () => props.openModal('suspend', rowData) } />
                  </Tooltip>}
                  <Tooltip title="Attach file">
                    <span>
                      <Badge className={ `${commonStyles.attachmentBadge}` } color="secondary" badgeContent={ rowData.attachment_count }>
                      <AttachFile className={  classes.materialIcon } onClick={ () => props.openAttachments(rowData) }/>
                      </Badge>
                    </span>
                  </Tooltip>
                  <Tooltip title="Print">
                    <Print className={ classes.materialIcon } onClick={ () => props.printOrderInfoClicked(rowData.number) } />
                  </Tooltip>
                </>
                }
                </span>;
            }
          }
        ]}

        options={{
          paging: false,
          pageSize: 10,
          headerStyle: {
            backgroundColor: 'var(--tbl_head_bkg)',
            color: 'var(--tbl_head_color)',
            zIndex: 2,
          },
          maxBodyHeight: 'calc(100vh - 360px)',
          rowStyle: (rowData: OrderDashboard) => ({
            color: (props.selectedOrderNumber === rowData.number) ? '#fff' : '#000',
            transition: '0s',
          }),
          showTitle: false,
          pageSizeOptions: [15, 20],
          toolbar: false,
          sorting: false
        }}
      />
    </div>
  );
  
};

export default withStyles(styles)(ghaOrdersList);
